import { Component } from '@angular/core';

@Component({
  selector: 'app-contact',
  standalone: false,
  templateUrl: './contact.component.html',
  styleUrl: './contact.component.scss'
})
export class ContactComponent {
  currentYear: number = new Date().getFullYear();
  formResponse: string = '';
  formError: string = '';
  isSubmitting: boolean = false;

  async handleSubmit(event: Event) {
    event.preventDefault();

    const form = event.target as HTMLFormElement;
    this.formResponse = '';
    this.formError = '';
    this.isSubmitting = true;

    const submitBtn = form.querySelector<HTMLButtonElement>('#submitBtn');
    if (submitBtn) submitBtn.disabled = true;

    const name = (form.elements.namedItem('name') as HTMLInputElement).value.trim();
    const email = (form.elements.namedItem('email') as HTMLInputElement).value.trim();
    const subject = (form.elements.namedItem('subject') as HTMLInputElement).value.trim();
    const message = (form.elements.namedItem('message') as HTMLTextAreaElement).value.trim();

    if (message.length < 10) {
      this.formError = '⚠️ Message must be at least 10 characters long.';
      this.isSubmitting = false;
      if (submitBtn) submitBtn.disabled = false;
      return;
    }

    if (message.length > 2000) {
      this.formError = '⚠️ Message too long. Please shorten your message (max 2000 characters).';
      this.isSubmitting = false;
      if (submitBtn) submitBtn.disabled = false;
      return;
    }

    const fullMessage = `Subject: ${subject}\n\n${message}`;

    const formData = { name, email, message: fullMessage };

    try {
      const response = await fetch('https://api.moretech.ps/api/support-email/contact', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify(formData)
      });

      const result = await response.json();

      if (response.ok) {
        this.formResponse = result.message || '✅ Your message has been sent successfully!';
        form.reset();
      } else {
        this.formError = result.error || '⚠️ Something went wrong. Please try again.';
      }
    } catch (error) {
      console.error('Contact form error:', error);
      this.formError = '⚠️ Could not send message. Please check your connection and try again.';
    } finally {
      this.isSubmitting = false;
      if (submitBtn) submitBtn.disabled = false;
    }
  }
}
